




"use strict";

export default class FaqOverview {

    constructor (elem) {
        if (elem) {
            this.elem = elem;
            this.nav = this.elem.querySelector('.faq-nav');

            if ( !this.elem.dataset.current ) {
                this.elem.dataset.current = this.getFirstCategorySlug();
            }

            this.nav.querySelectorAll('a').forEach(elem => {
                elem.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    this.setCurrentCategory(elem.dataset.slug);
                    this.updateUrl();
                });
            });

            window.onpopstate = evt => {
                if(evt.state && evt.state.category) {
                    this.setCurrentCategory(evt.state.category);
                }
            };

            this.showCurrentCategory();
            this.updateUrl();
        }
    }


    setCurrentCategory (category) {
        this.elem.dataset.current = category;
        this.showCurrentCategory();
    }


    updateUrl () {
        const url = '?category='+ this.elem.dataset.current;

        history.pushState({
            category: this.elem.dataset.current,
        }, '', url);
    }


    showCurrentCategory () {
        this.elem.querySelectorAll('.faq-category')
            .forEach(elem => {
                if ( elem.dataset.slug === this.elem.dataset.current ) {
                    elem.style.display = 'block';
                } else {
                    elem.style.display = 'none';
                }
            });

        this.nav.querySelectorAll('a')
            .forEach(elem => {
                if ( elem.dataset.slug === this.elem.dataset.current ) {
                    elem.classList.add('active');
                } else {
                    elem.classList.remove('active');
                }
            });
    }


    getFirstCategorySlug () {
        return this.nav.querySelector('a:first-child').dataset.slug;
    }
}
